export default "__VITE_ASSET__CO8Tb3zo__"